import styled from '@emotion/styled';
import { Typography } from 'antd';

export const Root = styled('div')<{ $isMobile: boolean }>`
  min-height: 100dvh;
  display: flex;
  flex-direction: ${({ $isMobile }) => ($isMobile ? 'column' : 'row')};
  justify-content: center;
`;

export const LeftPanel = styled('div')<{ $accentColor?: string }>`
  flex: 1;
  position: relative;
  overflow: hidden;
  background: ${({ $accentColor }) => $accentColor ?? '#393afb'};
`;

export const LeftContent = styled('div')`
  position: relative;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 48px;
  color: #ffffff;
  text-align: center;
`;

export const BrandTitle = styled('div')`
  font-size: 98px;
  line-height: 98px;
`;

export const Byline = styled('div')`
  display: flex;
  align-items: center;
  justify-content: right;
  gap: 10px;
  font-size: 14px;
  text-transform: uppercase;
`;

export const RightPanel = styled('div')<{ $isMobile: boolean }>`
  width: ${({ $isMobile }) => ($isMobile ? '100%' : '50%')};
  display: flex;
  align-items: center;
  justify-content: center;
  padding: ${({ $isMobile }) => ($isMobile ? '24px' : '48px')};
`;

export const RightContent = styled('div')<{ $isMobile: boolean }>`
  width: 100%;
  max-width: 440px;
  padding: ${({ $isMobile }) => ($isMobile ? '24px' : '32px')};
`;

export const Title = styled(Typography.Title)`
  margin-bottom: 0 !important;
`;

export const Subtitle = styled(Typography.Text)`
  color: rgba(0, 0, 0, 0.55);
`;

export const FormStack = styled('div')`
  margin-top: 28px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  justify-content: center;
`;
